import React, { useCallback, useEffect, useState } from "react";
import ReactPortal from "Components/ReactPortal/ReactPortal";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";
import CustomDraggable from "Common/CustomDraggable/CustomDraggable";

const AddNewPaymentCardPopup = ({ onClose, data, disableDraggable }) => {
  const uniqueId = "AddNewPaymentCardPopup"
  const [stripePromise, setStripePromise] = useState(null);
  useEffect(() => {
    (async () => {
      const response = await loadStripe(data.publishableKey);
      setStripePromise(response);
    })();
  }, [data.publishableKey]);

  const fetchClientSecret = useCallback(() => {
    return new Promise((resolve) => {
      resolve(data.client_secret);
    });
  }, [data.client_secret]);

  const options = { fetchClientSecret };

  return (
    <ReactPortal wrapperId={uniqueId}>
      <div
        data-te-modal-init
        className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
        id="exampleModalScrollable"
        tabIndex={-1}
        aria-labelledby="exampleModalScrollableLabel"
        aria-modal="true"
        data-te-open="true"
      >
        <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
          <div
            data-te-modal-dialog-ref
            className="relative w-[500px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
          >
            <div
              id={uniqueId}
              className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
            >
              Add New Payment Card
            </div>
            <div className="px-5 pt-5 overflow-y-auto max-h-[70vh]">
              {stripePromise && (
                <div id="checkout">
                  <EmbeddedCheckoutProvider
                    stripe={stripePromise}
                    options={options}
                  >
                    <EmbeddedCheckout />
                  </EmbeddedCheckoutProvider>
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
              <CustomButtonNew label="Cancel" variant="outline" onClick={onClose} />
            </div>
          </div>
        </CustomDraggable>
      </div>
    </ReactPortal>
  );
};

export default AddNewPaymentCardPopup;
